import { ErrorActionType, ErrorActionTypes } from "./constants"

export const apiError = (error: string): ErrorActionType => ({
  type: ErrorActionTypes.ERROR,
  payload: error,
})
